import {
  getTemperaturesByTable,
  getTemperaturesByTableAndSensor,
  getTemperaturesByMultipleTables,
  getTemperaturesPerDayByTable,
  getTemperaturesPerDayByTableAndSensor,
  getTemperaturesPerDayByMultipleTables,
  getTemperaturesPerHourByTable,
  getTemperaturesPerHourByTableAndSensor,
  getTemperaturesPerHourByMultipleTables,
  getEventsByTable,
  getEventsByMultipleTables,
  getRecordsByTable,
  getRecordsByMultipleTables,
  getTemperaturesStatisticalByMultipleTables,
  getTemperaturesStatisticalByTable,
} from '../services/sensor.service';

export function useTableDataSearch() {
  const search = async ({
    equipos,
    startDate,
    endDate,
    smoothingType,
    dataType,
    prefix,
    selectedSensor,
  }) => {
    let response;
    const isMultiple = prefix === 'Todos';
    const isSensorSelected = selectedSensor !== 'Todos';

    let selectedPrefix = prefix;
    let sensorNumber = null;

    if (isSensorSelected) {
      const [table, sensor] = selectedSensor.split('-');
      selectedPrefix = table;
      sensorNumber = parseInt(sensor.trim(), 10);
    }

    if (dataType === 'Temperaturas') {
      switch (smoothingType) {
        case 'Suavizado por día':
          response = isSensorSelected
            ? await getTemperaturesPerDayByTableAndSensor(
                selectedPrefix,
                sensorNumber,
                startDate,
                endDate
              )
            : isMultiple
            ? await getTemperaturesPerDayByMultipleTables(
                equipos,
                startDate,
                endDate
              )
            : await getTemperaturesPerDayByTable(
                selectedPrefix,
                startDate,
                endDate
              );
          break;

        case 'Suavizado por hora':
          response = isSensorSelected
            ? await getTemperaturesPerHourByTableAndSensor(
                selectedPrefix,
                sensorNumber,
                startDate,
                endDate
              )
            : isMultiple
            ? await getTemperaturesPerHourByMultipleTables(
                equipos,
                startDate,
                endDate
              )
            : await getTemperaturesPerHourByTable(
                selectedPrefix,
                startDate,
                endDate
              );
          break;

        default:
          response = isSensorSelected
            ? await getTemperaturesByTableAndSensor(
                selectedPrefix,
                sensorNumber,
                startDate,
                endDate
              )
            : isMultiple
            ? await getTemperaturesByMultipleTables(equipos, startDate, endDate)
            : await getTemperaturesByTable(selectedPrefix, startDate, endDate);
          break;
      }
    } else if (dataType === 'Eventos') {
      response = isMultiple
        ? await getEventsByMultipleTables(equipos, startDate, endDate)
        : await getEventsByTable(prefix, startDate, endDate);
    } else if (dataType === 'Registros') {
      response = isMultiple
        ? await getRecordsByMultipleTables(equipos, startDate, endDate)
        : await getRecordsByTable(prefix, startDate, endDate);
    }

    return response;
  };

  const searchStadistics = async ({
    equipos,
    startDate,
    endDate,
    prefix,
    selectedSensor,
  }) => {
    let response;
    const isMultiple = prefix === 'Todos';
    const isSensorSelected = selectedSensor !== 'Todos';

    let selectedPrefix = prefix;
    let sensorNumber = null;

    if (isSensorSelected) {
      const [table, sensor] = selectedSensor.split('-');
      selectedPrefix = table;
      sensorNumber = parseInt(sensor.trim(), 10);
    }

    response = isMultiple
      ? await getTemperaturesStatisticalByMultipleTables(
          equipos,
          startDate,
          endDate
        )
      : await getTemperaturesStatisticalByTable(
          selectedPrefix,
          startDate,
          endDate
        );
    // Si hay un sensor seleccionado, devolver solo ese dato
    if (isSensorSelected) {
      if (Array.isArray(response)) {
        // Respuesta de múltiples tablas
        const filtered = [response[sensorNumber]];

        return filtered;
      }
    }

    // Si no hay sensor seleccionado, retornar todo
    return response;
  };

  return { search, searchStadistics };
}
